import { FC, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { StepRenderProps } from "@/components/onboarding/components/welcome-wizard";
import { OnboardingMeetingsPermissionsSetup } from "@/components/onboarding/components/welcome-wizard/steps/system-permissions-meetings/components";
import { useOnboardingSystemPermissionsHandlers } from "@/components/onboarding/components/welcome-wizard/shared";
import { useAppStore } from "@/store";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { TrackedEvent, trackEvent } from "@/domains/metrics";

export const SystemPermissionsMeetingPermissionsStep: FC<StepRenderProps> = observer(
  ({ onComplete }) => {
    const { store } = useAppStore();

    const showFinish = store.onboarding.showFinish;

    const handleNext = useCallback(
      ({ autoMeetingDetectionEnabled }: { autoMeetingDetectionEnabled: boolean }) => {
        trackEvent(TrackedEvent.MeetingNotificationsSetupSubmit, {
          enabled: autoMeetingDetectionEnabled,
        });

        onComplete();
      },
      [onComplete]
    );

    const { resolveConfigurationStatus, handleEnablePermission, handleOpenPermissionPane } =
      useOnboardingSystemPermissionsHandlers();

    useEffectOnMount(() => {
      trackEvent(TrackedEvent.MeetingNotificationsSetupView);
    });

    return (
      <OnboardingMeetingsPermissionsSetup
        onNext={handleNext}
        showFinish={showFinish}
        resolveConfigurationStatus={resolveConfigurationStatus}
        handleEnablePermission={handleEnablePermission}
        handleOpenPermissionPane={handleOpenPermissionPane}
        platform={{
          isMacOs: store.interface.isMacOs,
          isIntelMacDesktop: store.electron.isIntelMacDesktop,
        }}
      />
    );
  }
);
